module.exports = __webpack_public_path__ + "img/btn_have_weapon_on.622cad9f.svg";